import { Report } from '@cims-online/shared'
import AnchorButton from 'components/AnchorButton'
import { useEffect, useState } from 'react'
import { useSingleReportsContext } from '../../SingleReportsContext'
import { useReportRecordSelectContext } from 'components/CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'
import { useAnyTrue } from 'hooks/useAnyTrue'
import {
  useGetCasPacketDownloadUrlQuery,
  useGetConcretePacketDownloadUrlQuery,
} from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

const GenerateSingleButton: React.FC = () => {
  const { projectId } = useProjectContext()
  const { loading } = useReportRecordSelectContext()
  const { globalId, report } = useSingleReportsContext()
  const [href, setHref] = useState<string | null | undefined>()
  const dependencies = useReportURLDependencies()
  const [downloadUrl, setDownloadUrl] = useState<string | null | undefined>()
  const getCasPacket = useGetCasPacketDownloadUrlQuery({
    ...DefaultQueryHookOptions,
    skip: !globalId || report?.id !== Report.ConstructionAdminSubmittal.id,
    variables: { submittalId: globalId! },
    onCompleted: ({
      constructionAdminSubmittal: { packetSharePointResource },
    }) => setDownloadUrl(packetSharePointResource?.downloadUrl),
  })
  const getConcretePacket = useGetConcretePacketDownloadUrlQuery({
    ...DefaultQueryHookOptions,
    skip: !globalId || report?.id !== Report.ConcreteTestSet.id,
    variables: { testSetId: globalId! },
    onCompleted: ({ concreteTestSet: { packetSharePointResource } }) =>
      setDownloadUrl(packetSharePointResource?.downloadUrl),
  })
  const [gettingDownloadUrl] = useAnyTrue([
    getCasPacket.loading,
    getConcretePacket.loading,
  ])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    if (!globalId || !report) setHref(undefined)
    else if (report.queryParameter === 'packet') setHref(downloadUrl)
    else if (report.queryParameter === 'construction-admin-submittal')
      setHref(downloadUrl)
    else setHref(report.toURL({ ...dependencies, globalId }))
  }, [downloadUrl, globalId, report, projectId, dependencies])

  return (
    <AnchorButton
      href={href}
      type="primary"
      loading={loading || gettingDownloadUrl}
      disabled={loading || gettingDownloadUrl || !href}
    >
      {report ? `Get ${report.name}` : 'Select a Report'}
    </AnchorButton>
  )
}

export default GenerateSingleButton
